import Cookies from 'universal-cookie';

export default function AuthCookies() {
  const cookies = new Cookies();

  const set = (key:string, value:string, expiresInMin :number) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (expiresInMin * 60 * 1000));
    cookies.set(key, value, { path: '/', expires });
  };

  const getJwt = ():string => cookies.get('CSAccount_jwt');

  const getAddress = ():string => cookies.get('CSAccount_address');

  const setAddress = (address:string) => {
    set('CSAccount_address', address, 60);
  };

  const setJwt = (jwt:string) => {
    set('CSAccount_jwt', jwt, 60);
  };

  return {
    getAuthCookie: getJwt,
    setAuthCookie: setJwt,
    setAddress,
    getAddress,
  };
}
